import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type { RoleRequest, RoleResponse } from '@/types/role';

export const rolesApi = {
  listAssignable: (params?: { employeeId?: number }) =>
    unwrap(api.get<ApiResponse<RoleResponse[]>>('/v1/roles/assignable', { params })),

  list: (params?: SearchParams) =>
    unwrap(api.get<ApiResponse<PageResponse<RoleResponse>>>('/v1/roles', { params })),

  get: (id: number) => unwrap(api.get<ApiResponse<RoleResponse>>(`/v1/roles/${id}`)),

  create: (body: RoleRequest) =>
    unwrap(api.post<ApiResponse<RoleResponse>>('/v1/roles', body)),

  update: (id: number, body: RoleRequest) =>
    unwrap(api.put<ApiResponse<RoleResponse>>(`/v1/roles/${id}`, body)),

  delete: (id: number) => unwrap(api.delete<ApiResponse<null>>(`/v1/roles/${id}`)),
};
